import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DefaultLandingPageComponent from './DefaultLandingPageComponent';

const mapStateToProps = (state) => ({
  landingPage: state.LayoutReducer.landingPage
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLandingPageComponent);
